import app from '../app';

const windowModeTypes = [
    'IdentificationAndNeedCommercial',
    'NeedCommercialWithoutIdentification',
    'OnCommercialDepositRequiredWithoutIdentification',
    'OnCommercialDepositRequiredWithIdentification',
    'NeedCommercialForCurrentCategory',
    'HomeownerAndNeedIdentification',
];
const TYPE_REQUIRED_IDENTIFICATION = 'HomeownerAndNeedIdentification';

app.service('pubAvailService', [
  '$rootScope', 'apiService', 'geoService', 'addFormService', 'popupService', 'userIdentificationService',
  'telemetryService', 'publishTermsService',
  function (
    $rootScope, apiService, geoService, addFormService, popupService, userIdentificationService, telemetryService, publishTermsService,
  ) {
    let pubAvailModalInstance;

    this.isNeedIdentification = false;

    /**
     * Проверяем, возможна ли публикация в данной категории, по указанному адресу. Вызывается при смене категории или адреса.
     * Публикацию запрещаем только в случае успешного ответа и popUpActionType === 'Show'. Во всех других случаях, включая ошибки сервера,
     * считаем, что публикация возможна.
     * От этого метода зависит видимость условий размещения и кнопки публикации.
     * @param category
     * @param locationPath
     * @return {*}
     */
    const checkPubAvailRequest = (category, locationPath) => {
      this.isAvailable = undefined;
      this.showPopup = false;
      this.isLoading = true;
      this.isFailed = false;

      telemetryService.mark('addform.publication-availability-start');

      const params = {
        category,
        locationPath: locationPath.join(','),
        latitude: geoService.getCoordinates().lat,
        longitude: geoService.getCoordinates().lng,
        isByHomeowner: addFormService.ad && addFormService.ad.isByHomeowner,
      };

      const realtyObjectId = addFormService.ad.id;

      if (realtyObjectId) {
        params.realtyObjectId = realtyObjectId;
      }

      return apiService.getPubAvail(params)
        .then((data) => {
          telemetryService.mark('addform.publication-availability-end');
          telemetryService.sendMeasuredTimer(
            'addform.publication-availability-request',
            'addform.publication-availability-start',
            'addform.publication-availability-end',
          );

          if (!data) {
            throw new Error('Publication availability service: no data in API response');
          }

          if (data.popUpActionType === 'Show' && !windowModeTypes.includes(data.windowModeType)) {
            throw new Error(`Publication availability service: unknown windowModeType (${data.windowModeType})`);
          }

          this.showPopup = data.popUpActionType === 'Show';
          this.pubAvailData = data;
        })
        .catch(() => {
          this.isFailed = true;
        })
        .finally(() => {
          this.isAvailable = !this.showPopup;
          this.isLoading = false;
        });
    };

    // publication availability
    this.checkPubAvail = (category, locationPath) => {
      this.ad = $rootScope.ad;

      checkPubAvailRequest(category, locationPath)
        .then(() => {
          this.isNeedIdentification = this.pubAvailData
            && TYPE_REQUIRED_IDENTIFICATION === this.pubAvailData.windowModeType
            // на новом ФВУ временно оставляем старый флоу идентификации
            && !publishTermsService.isNewPublishTermsEnabled();

          userIdentificationService.setIsUserNeedIdentification(this.isNeedIdentification);

          // Если нужна идентификация через sumsub не нужно показывать ни попап, ни информационный блок
          // если включен флаг identificationInstruction.onlyDocumentsAllowed то идем новым флоу
          // и показываем попап
          const isOnlyDocuments = this.pubAvailData?.identificationInstruction?.onlyDocumentsAllowed;
          // если есть кука идентификации, не новый флоу или новый флоу и соб
          if (this.isNeedIdentification && (!isOnlyDocuments || addFormService.ad.isByHomeowner)) {
            this.showPopup = false;
            this.isAvailable = false;
            this.pubAvailPopupShown = true;

            return;
          }

          if (!this.showPopup) {
            // прячем попап если он уже показан
            // такое возможно, если пользователь изменил адрес до того как сервис вернул ответ по старому адресу
            // todo: использовать таймаут-промис в pubAvailService.checkPubAvail вместо этого
            if (popupService.isOpen('pubAvail')) {
              pubAvailModalInstance && pubAvailModalInstance.dismiss();
            }
          } else if (!this.pubAvailPopupShown) {
            this.pubAvailPopupShown = true; // show only once
            pubAvailModalInstance = popupService.openPopup('pubAvail');
          }
      });
    };

    this.saveDraftForIdentification = () => {
      this.ad.status = 'draft';
      $rootScope.$broadcast('publish.skipPremoderationCheck');
    };
  },
]);
